export default __webpack_public_path__ + "static/media/PowerSupplyImg.50871efc.jpg";